export default __webpack_public_path__ + "static/media/rnr-sports-table-17.c20d37a1.webp";